import React from "react";

import { Column } from "@gamedev-web/gamedev-sdk-core";

import {
  submissionErrorMessage,
  submissionErrorTitle,
  tryAgain,
} from "../gdkMiddlewarePageContent";
import * as styles from "../GdkMiddlewareRequestPage.module.css";

export type SubmissionErrorStepProps = {
  onRetry: () => void;
};

export const SubmissionErrorStep = ({ onRetry }: SubmissionErrorStepProps) => (
  <Column className={styles.innerContentBox}>
    <h4>{submissionErrorTitle}</h4>
    <p>{submissionErrorMessage}</p>
    <div>
      <button className={styles.actionButton} onClick={onRetry}>
        {tryAgain}
      </button>
    </div>
  </Column>
);
